import "./table.scss";
import { useEffect, useState, useContext } from "react";
import { db } from '../../firebase';
import { collection, getDocs, query, where } from "firebase/firestore";
import { AuthContext } from "../../context/AuthContext";
import { DataGridPro, GridToolbar } from '@mui/x-data-grid-pro';
import { Link } from "react-router-dom";
import SearchIcon from '@mui/icons-material/Search';

/**
 * Hook que maneja la carga de documentos y muestra una vista de carga mientras se obtienen los datos.
 * @param {string} tipVS - El parámetro tipVS recibido desde el URL.
 * @param {string} vigilante - El ID del vigilante específico.
 * @returns {JSX.Element} - Componente List con la vista de carga o los documentos filtrados.
 */
const List = ({ email }) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const { currentUser } = useContext(AuthContext);

  const fetchDocuments = async () => {
    try {
      const serviciosRef = collection(db, 'servicios');
      const q = query(serviciosRef, where('admins', 'array-contains', currentUser.email));
      const querySnapshot = await getDocs(q);
      const documents = [];

      for (const doc of querySnapshot.docs) {
        const servicioId = doc.id;
        const documentsRef = collection(serviciosRef, servicioId, 'documents');
        const docsQuery = query(documentsRef, where('vigilante', '==', email));
        const documentsSnapshot = await getDocs(docsQuery);
        documentsSnapshot.forEach((document) => {
          const documentData = { id: document.id, ...document.data() };
          // Procesar la fecha
          const timestamp = documentData.fecha;
          const seconds = timestamp.seconds;
          const nanoseconds = timestamp.nanoseconds;
          const date = new Date(seconds * 1000 + nanoseconds / 1000000);
          const dia = date.getDate();
          const mes = date.getMonth() + 1;
          const año = date.getFullYear();
          const fechaFormateada = `${dia}/${mes}/${año}`;
          documentData.fecha = fechaFormateada;
          documents.push(documentData);
        });
      }
      setRows(documents);
    } catch (error) {
      console.error('Error al obtener los documentos:', error);
    }
  };

  useEffect(() => {
    if (!email) return;
    setLoading(true);
    fetchDocuments().then(() => setLoading(false));
  }, [email]);

  const columns = [
    { field: 'documentTypeId', headerName: 'Tipo de reporte', flex: 1, minWidth: 180 },
    { field: 'fecha', headerName: 'Fecha', flex: 1, minWidth: 120 },
    {
      field: 'action',
      headerName: 'Acciones',
      flex: 1,
      minWidth: 120,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <div className="cellAction">
          <Link to={`/vigilantes/details/${params.row.id}`}>
            <div className="viewButtonSingle">Ver</div>
          </Link>
        </div>
      ),
    },
  ];

  return (
    <div className="tableContainerSingle">
      <h2 className="datatableTitle">Reportes</h2>
      <div style={{ height: 600, width: '100%', background: '#fff', borderRadius: 12, boxShadow: '0 2px 8px #e3e7ed' }}>
        <DataGridPro
          rows={rows}
          columns={columns}
          loading={loading}
          pageSize={50}
          rowsPerPageOptions={[50]}
          disableSelectionOnClick
          components={{ Toolbar: GridToolbar }}
          localeText={{ toolbarColumns: 'Columnas', toolbarFilters: 'Filtros', toolbarDensity: 'Densidad', toolbarExport: 'Exportar' }}
          getRowId={(row) => row.id}
        />
      </div>
    </div>
  );
};

export default List;
